import { createRouter, createWebHistory } from 'vue-router';

import NotFound from '@lib/pages/NotFound.vue';

import lib_routes from '@lib/router';
import { extensionRoutes } from '@lib/extensions';

const router = createRouter({
	history: createWebHistory(),
	routes: [
		{
			path: '/',
			redirect: { name: 'Home' },
			component: () => import('@lib/layouts/Dashboard/Main.vue'),
			meta: { auth: true },
			children: [
				// User pages
				{ path: 'dashboard', name: 'Home', component: () => import('@/pages/Dashboard.vue') },
				{ path: 'shop', name: 'Shop', component: () => import('@/pages/Buyer/Shop.vue') },
				{ path: 'cart', name: 'Cart', component: () => import('@/pages/Buyer/Cart.vue') },
				{ path: 'orders', name: 'Order', component: () => import('@/pages/Buyer/Orders.vue') },
				{ path: 'delivery', name: 'Delivery', component: () => import('@/pages/Buyer/CartItemDelivery.vue') },
				{
					path: 'orders/:order_id',
					name: 'Review',
					component: () => import('@/pages/Buyer/OrderReview/Review.vue'),
				},

				// Share
				{ path: 'articles/:article_id', component: () => import('@/pages/Article/Article.vue') },

				// Seller pages
				{ path: 'seller/articles', component: () => import('@/pages/Seller/Articles.vue') },
				{ path: 'seller/orders', component: () => import('@/pages/Seller/Orders.vue') },
				{ path: 'seller/orders/:order_id', component: () => import('@/pages/Seller/Order/Review.vue') },
				{ path: 'seller/order_items', component: () => import('@/pages/Seller/CartItems.vue') },
				{ path: 'seller/delivery', component: () => import('@/pages/Seller/CartItemDelivery.vue') },
				{ path: 'seller/map', component: () => import('@/pages/Seller/Map.vue') },

				// Event pages
				{ path: 'event/articles', component: () => import('@/pages/Event/Articles.vue') },
				{ path: 'event/orders', component: () => import('@/pages/Event/Orders.vue') },
				{ path: 'event/orders/:order_id', component: () => import('@/pages/Event/Order/Review.vue') },
				{ path: 'event/order_items', component: () => import('@/pages/Event/CartItems.vue') },
				{ path: 'event/delivery', component: () => import('@/pages/Event/CartItemDelivery.vue') },
				{ path: 'event/map', component: () => import('@/pages/Event/Map.vue') },

				// Context pages
				{ path: 'event/settings', component: () => import('@/pages/Event/Settings/Settings.vue') },
				// The lib's settings page of a record: its tabs come from the extensions and from the app (app.ts)
				{
					path: 'team/settings',
					component: () => import('@lib/pages/Context/ContextSettings.vue'),
					props: { context: 'team' },
				},

				// Admin pages
				{ path: 'admin/users', component: () => import('@lib/pages/Admin/Users.vue') },

				{ path: 'admin/events', component: () => import('@lib-ext/events/js/pages/Events.vue') },
				{ path: 'admin/events/:event_id', component: () => import('@/pages/Event/Settings/Settings.vue') },

				{ path: 'admin/teams', component: () => import('@/pages/Admin/Teams.vue') },
				{
					path: 'admin/teams/:team_id',
					component: () => import('@lib/pages/Context/ContextSettings.vue'),
					props: (route) => ({ context: 'team', id: route.params.team_id }),
				},

				{ path: 'admin/settings', component: () => import('@lib/pages/Admin/Settings/Settings.vue') },
				{
					path: 'admin/webhook_incomings/:id',
					component: () => import('@lib/pages/Admin/Settings/WebhookIncomingRequests.vue'),
				},
				{
					path: 'admin/webhook_outgoings/:id',
					component: () => import('@lib/pages/Admin/Settings/WebhookOutgoingRequests.vue'),
				},
				{ path: 'admin/maintenance', component: () => import('@lib/pages/Maintenance/Maintenance.vue') },
				{ path: 'admin/development', component: () => import('@lib/pages/Development/Development.vue') },

				// User profile pages
				{ path: 'me', name: 'Profile', component: () => import('@lib/pages/Me/Me.vue') },

				// The pages of the extensions that are on, e.g. the MCP server's info page (admin/mcp)
				...extensionRoutes(),

				// Some default routes
				{
					path: '/no-event-available',
					name: 'NoEventAvailable',
					component: () => import('@lib/pages/NoEventAvailable.vue'),
				},
				{ path: ':pathMatch(.*)*', name: '404', component: NotFound },
			],
		},
		...lib_routes,
	],
});

export default router;
